<template>
  <div class="detail">
    <div class="title"><span>{{title}}</span><span> > </span></div>
    <div class="article">
      <h1>{{article.title}}</h1>
      <!-- <div class="article-info">{{article.update_time}}</div> -->
      <div class="content" v-html="article.content">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArticleDetail',
  data() {
    return {
      id: '',
      title: '', // 分类
      article: {}
    }
  },
  created() {
    let {id} = this.$route.query
    this.id = id
    this.getArticle(this.id)
  },
  methods: {
    getArticle(id) {
      this.$http.get('/Article/getArticleInfo', {
        params: {
          id
        }
      })
        .then(response => {
          this.title = response.data.data.data.category_name
          this.article = response.data.data.data
        })
    }
  }
}
</script>

<style lang='less' scoped>
.detail {
  width: 980px;
  margin: 0 auto;
}
.clear {
  clear: both;
}
.title {
  font-size: 26px;
  font-weight: bold;
  line-height: 60px;
  span:nth-child(1) {
    display: inline-block;
    width: 55px;
    border-bottom: 3px solid red;
  }
  span:nth-child(2) {
    display: inline-block;
    width: 915px;
    padding-left: 10px;
    font-size: 16px;
    vertical-align: middle;
    font-weight: normal;
    color: #333;
    border-bottom: 3px solid #ccc;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
  }
}
.article {
  h1 {
    text-align: center;
    margin: 20px 0;
    // position:sticky;
    background-color: #fff;
  }
  .article-info {
    color: #333;
    font-size: 16px;
  }
}
</style>